function toText(value) {
  return String(value ?? "").trim();
}

function normalizeAddress(value) {
  const text = toText(value);
  if (!text) return "";
  return text.toLowerCase();
}

function parseTokenFromId(idValue) {
  const idText = toText(idValue);
  if (!idText) return "";
  if (!idText.includes(":")) return idText;
  const parts = idText.split(":");
  return toText(parts[parts.length - 1]);
}

function normalizeIpfsUrl(value) {
  const text = toText(value);
  if (!text) return "";
  if (!text.startsWith("ipfs://")) return text;
  const cidPath = text.slice("ipfs://".length).replace(/^ipfs\//, "");
  return cidPath ? `https://ipfs.io/ipfs/${cidPath}` : "";
}

function parseTextArray(value) {
  if (Array.isArray(value)) {
    return value
      .map((item) => toText(item))
      .filter(Boolean);
  }
  if (value == null) return [];
  const text = toText(value);
  if (!text) return [];
  try {
    const parsed = JSON.parse(text);
    if (Array.isArray(parsed)) return parseTextArray(parsed);
  } catch {
    if (text.startsWith("{") && text.endsWith("}")) {
      return parseTextArray(
        text
          .slice(1, -1)
          .split(",")
          .map((item) => item.trim().replace(/^"|"$/g, "")),
      );
    }
    return [text];
  }
  return [];
}

function normalizeImageList(values = []) {
  return Array.from(
    new Set(
      (Array.isArray(values) ? values : [])
        .map((item) => normalizeIpfsUrl(item))
        .filter(Boolean),
    ),
  );
}

export function resolveTokenId(input) {
  if (input == null) return "";
  if (typeof input !== "object") return parseTokenFromId(input);

  return parseTokenFromId(
    input.tokenId ?? input.token_id ?? input.tokenid ?? input.id ?? "",
  );
}

export function resolveNftAddress(input) {
  if (input == null) return "";
  if (typeof input !== "object") return normalizeAddress(input);

  return normalizeAddress(
    input.nftAddress ?? input.nft_address ?? input.nft ?? "",
  );
}

export function resolveNftGalleryImages(input) {
  if (!input || typeof input !== "object") return [];
  return normalizeImageList(parseTextArray(input.gallery_images));
}

export function resolveNftImage(input) {
  if (!input || typeof input !== "object") return "";
  const primaryCandidates = [
    input.image,
    input.coverImage,
    input.cover_image,
    input.thumbnail,
  ];

  for (const candidate of primaryCandidates) {
    const normalized = normalizeIpfsUrl(candidate);
    if (normalized) return normalized;
  }

  const gallery = resolveNftGalleryImages(input);
  return gallery[0] || "";
}

export function buildNftIdentityKey(nftAddress, tokenId) {
  const addr = normalizeAddress(nftAddress);
  const token = parseTokenFromId(tokenId);
  if (!token) return "";
  return addr ? `${addr}:${token}` : `:${token}`;
}

export function buildNftIdentityKeyFromRow(row) {
  return buildNftIdentityKey(resolveNftAddress(row), resolveTokenId(row));
}
